<script setup lang="ts">
import { useSliderThumb, type SliderThumbProps } from "@formwerk/core";

const props = defineProps<SliderThumbProps>();
const { thumbProps } = useSliderThumb(props);
</script>

<template>
  <div v-bind="thumbProps" class="input-default focus-default size-6 cursor-pointer rounded-full bg-primary" />
</template>
